import { dcFactory, DcBaseComponent } from '@deleteagency/dc';

export default class SocialSharingComponent extends DcBaseComponent {
    _isOpened = false;

    static getNamespace() {
        return 'share-collapsed';
    }

    static getRequiredRefs() {
        return ['trigger', 'tray', 'toolbox'];
    }

    onInit() {
        this.mobsharetray = $(".search-results-tabs__share-tray");
        if (this.refs.trigger && this.refs.tray) {
            this.addListener(this.refs.trigger, 'click', this._onTriggerClick);                        
            if (!!window.WINKWORTH_ShareThis) {
              window.WINKWORTH_ShareThis.push(this.refs.toolbox);
              if (this.mobsharetray.length) {
                this.mobsharetray.push(shareThis);
              }
            } else {
                window.WINKWORTH_ShareThis = [this.refs.toolbox];
            }
        }     
    }

    _onTriggerClick = (e) => {
        e.preventDefault();
        if (this._isOpened) {
            this._close();
        } else {
            this._open();
        }
    };

    _handleClickOutside = (e) => {
        if (!this._isOpened || !e.target || this.refs.tray.contains(e.target)) return;
        this._close();
    };

    _open() {
        this.refs.tray.style.maxHeight = this.contentHeight + 'px';
        this.refs.tray.classList.add('tray-open');
        this.refs.tray.classList.remove('tray-closed');
        this._isOpened = true;
        dcFactory.init(this.refs.tray, true);
        setTimeout(() => {
            document.addEventListener('click', this._handleClickOutside);
        }, 100);

        if (this.mobsharetray.length) {
            this.mobsharetray.addClass('open');
            this.mobsharetray.removeClass('closed');
        }
    }

    _close() {
        document.removeEventListener('click', this._handleClickOutside);
        this.refs.tray.classList.add('tray-closed');
        this.refs.tray.classList.remove('tray-open');
        this.refs.tray.style.maxHeight = 0 + 'px';
        this._isOpened = false;

        if (this.mobsharetray.length) {
            this.mobsharetray.addClass('closed');
            this.mobsharetray.removeClass('open');
        }
    }

    get contentHeight() {
        return this.refs.toolbox.clientHeight;
    }
}
